(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('AgreementValuation', AgreementValuation);

    AgreementValuation.$inject = ['$resource'];

    function AgreementValuation ($resource) {
        var resourceUrl =  'api/agreement-valuations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
